import { GET_LEADS_CAP_MODELS_REQUEST, GET_LEADS_CAP_MODELS_REQUEST_SUCCESS, GET_LEADS_CAP_MODELS_REQUEST_FAILURE } from '../../constants/cap.constants';

export const getLeadsCapModelsRequest = brand_id => ({ type: GET_LEADS_CAP_MODELS_REQUEST, brand_id });
export const getLeadsCapModelsRequestSuccess = payload => ({ type: GET_LEADS_CAP_MODELS_REQUEST_SUCCESS, payload });
export const getLeadsCapModelsRequestFailure = error => ({ type: GET_LEADS_CAP_MODELS_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/actions/cap_actions/get_cap_models.actions.js